import React, { Component } from "react";
import { Switch, Route } from "react-router-dom";
import { Row, Column } from "react-foundation";

import ItemBuilderPage from "containers/ItemBuilderPage";
import SummaryPage from "containers/SummaryPage";
import GetQuotePage from "containers/GetQuotePage";
import LoadEnquiryData from "containers/LoadEnquiryData";
import Header from "components/Header";
import GoogleRouteTracker from './components/GoogleRouteTracker';
import Thanks from './containers/AdditionalForm/Thanks';

import "react-select/dist/react-select.css";
import "css/App.css";

class App extends Component {
    render() {
        return (
            <div className="App">
                <Header />
                <Row collapseOnSmall uncollapseOnMedium style={{ height: "100%" }}>
                    <Column small={12} style={{ height: "100%" }}>
                        <Switch>
                            <Route path="/Thanks" component={Thanks} />
                            <Route path="/Item" component={ItemBuilderPage} />
                            <Route path="/Summary" component={SummaryPage} />
                            <Route path="/GetQuote" component={GetQuotePage} />
                            <Route path="/:customerGuid?/:enquiryUid?" component={LoadEnquiryData} />

                            {/* {<Redirect from="/" to="/Item/Selector" />} */}
                        </Switch>
                    </Column>
                </Row>
                <Route path="/" component={GoogleRouteTracker} />
            </div>
        );
    }
}

export default App;



// WEBPACK FOOTER //
// ./src/App.js